<template>
  <div :id="componentId" class="how-to-diagnose-block">
    <h1 v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="diagnose-main-title">
      {{ diagnoseData.title }}
    </h1>
    <h2 v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="diagnose-main-subtitle">
      {{ diagnoseData.description }}
    </h2>
    <div v-for="(product, index) in diagnoseData.diagnoseSection" :key="index">
      <h1
        v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
        class="diagnose-product-title"
      >
        {{ product.title }}
      </h1>
      <h2
        v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
        class="diagnose-product-subtitle"
      >
        {{ product.description }}
      </h2>
      <div
        v-if="product.image"
        v-animate-onscroll.repeat="{ down: 'animated zoomIn' }"
        class="diagnose-product-image"
      >
        <img :src="product.image.Src" :alt="product.image.Alt" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'how-to-diagnose',
  props: {
    diagnoseData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentId: 'how-to-diagnose',
    };
  },
  mounted() {
    document.addEventListener('scroll', this.menuHighlight);
  },
  methods: {
    menuHighlight() {
      const componentBlock = document.getElementById(this.componentId);
      if (componentBlock) {
        const checkOffset = componentBlock.offsetTop - 120;
        if (window.pageYOffset >= checkOffset) {
          window.eventBus.$emit('summary-menu-highlight', this.componentId);
        }
      }
    },
  },
};
</script>
